<template>
  <nav class="add-navigation flex-wrap d-flex w-100">
      <search-input
        v-if="search"
        class="search-input my-2 mr-3 "
        type="text"
        :value="searchFirstVal"
        @input="handleSearch"
        :placeholder="'Search for ' + search.placeholder"
      />
      <div class="selects-wrapper d-flex align-items-center my-2 width   sm-flex-wrap" v-if="filter">
        <span class="filter_by mr-2  white_space ">Filter by:</span>
        <primary-select
          type="text"
          class="choose-type mr-3 "
          placeholder="Select an option"
          :value="filterVal"
          @input="handleFilter"
          :options="filter.options"
        />
      </div>
      <search-input
        v-if="search_second"
        class="search-input mr-2 my-1"
        type="text"
        :value="searchSecondVal"
        @input="handleSecondSearch"
        @keyup.enter.native="handleEnterPress"
        :placeholder="'Search for ' + search_second.placeholder"
      />
    <div class="buttons-wrapper ">
      <div class="primary-button mr-3 my-2" v-if="search_button">
        <primary-button @click.native="handleSearchByButton">Search</primary-button>
      </div>
      <div class="primary-button my-2 mr-3  " v-if="reset">
        <primary-button @click.native="resetButton">Reset</primary-button>
      </div>
    </div>
    <div class="show-active-items d-flex align-items-center my-2 mr-3" v-if="!search_button" >
      <input type="checkbox" id="show-active" class="active-checkbox mr-2 " @change="changeCheckbox" />
      <label for="show-active" class="mb-0">Active Only</label>
    </div>

    <div class="buttons-wrapper ml-xl-auto ">
      <div class="primary-button my-2" v-if="addButtton" :class="addButtton.class">
        <primary-button @click.native="handleAdd" >{{addButtton.text}}</primary-button>
      </div>
      <div class="primary-button" v-if="downloadButtton" >
        <primary-button @click.native="handleDownload">{{downloadButtton.text}}</primary-button>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  components: {
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
  },
  props: [
    "search",
    "filter",
    "addButtton",
    "search_second",
    "search_button",
    "reset",
    "downloadButtton",
    "download",
  ],
  data: () => ({
    searchFirstVal: null,
    searchSecondVal: null,
    filterVal: null,
  }),
  methods: {
    changeCheckbox(e) {
      this.$emit("changeCheckbox", e.target.checked);
    },
    handleSearch(v) {
      this.$emit("search", v);
    },
    handleFilter(v) {
      this.$emit("filter", v);
      this.filterVal = v
    },
    handleSecondSearch(v) {
      this.searchValue = v;
      this.$emit("searchSecond", v);
    },
    handleEnterPress() {
      this.$emit("searchByButton");
    },
    handleAdd() {
      this.$emit("add");
    },
    handleDownload() {
      this.$emit("download");
    },
    handleSearchByButton() {
      this.$emit("searchByButton");
    },
    resetButton() {
      Object.assign(this.$data, {
        searchFirstVal: "",
        searchSecondVal: null,
        filterVal: null,
      });
      this.$emit("reset");
    },
  },
};
</script>

<style>
.invoice-container.view .add-navigation.btn .show-active-items {
  display: none;
}
</style>

<style lang="scss" scoped>
.add-navigation {
  display: flex;
  align-items: center!important;
  height: fit-content;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 0;

  .buttons-wrapper {
    display: flex;
    align-items: center;
    width: fit-content;
    .primary-button {
      height: 40px;
      min-width: fit-content;
      white-space: nowrap;
    }
  }
}
@media screen and (max-width: 1855px) {
  .add-navigation {
    .right-wrapper {
      .selects-wrapper {
        margin-bottom: 20px;
      }
      .primary-button {
        margin-bottom: 20px;
      }
      .select {
        margin-bottom: 20px;
      }
      .search-input {
        margin-bottom: 20px;
      }
    }
    .buttons-wrapper {
      margin-top: 0;
    }
  }
}

.search-input {
 max-width: 275px;
}

.choose-type {
  min-width: 200px;
}
.active-checkbox {
     width: 20px;
     height: 20px;
     margin-right: 10px;
   }
@media (max-width: 617px) {
  .search-input {
    min-width: 100%;
  }

  .width {
   width: 100%;
  }
}
</style>